import {getPackages} from "../resources/StowResource";
import {Capability, PackageStatus} from "../enums";
import {publishCount, publishTime} from "../MetricUtility";
import {ERROR_METRIC_SUFFFIX, FLOOR, FLOOR_LOCATION, GROUP_BY, PACKAGE_STATUS, STATION_PAIR} from "../constants";
import {getPickPackages} from "../resources/PickResource";
import {getDateInMMDDYYYYWithOffset, getSidelineRangeFilter} from "../Utility";

export const LOAD_PACKAGE_LIST_BEGIN = "LOAD_PACKAGE_LIST_BEGIN";
export const LOAD_PACKAGE_LIST_SUCCESS = "LOAD_PACKAGE_LIST_SUCCESS";
export const LOAD_PACKAGE_LIST_FAILURE = "LOAD_PACKAGE_LIST_FAILURE";

const metricProcessName = "SCC_STOW_PACKAGES";

const loadPackageListBegin = () => ({
    type: LOAD_PACKAGE_LIST_BEGIN
});

const loadPackageListSuccess = (packageList) => ({
    type: LOAD_PACKAGE_LIST_SUCCESS,
    packageList
});

const loadPackageListFailure = () => ({
    type: LOAD_PACKAGE_LIST_FAILURE,
});

export const fetchPackageListForFilters = (nodeId, params, capability) => {

    const metricName = "getPackages";

    const request = {
        filters: {
            'NODE': [nodeId],
        }
    }
    for (const pair of params.entries()) {
        request.filters[pair[0]] = [pair[1]];
    }

    if (Capability.AR_NEXT_GEN !== capability && !request.filters['ROUTE_ID']
        && !request.filters['DRS'] && !request.filters['SIDELINE']
        && !request.filters['SIDELINE_V2'] &&
        (request.filters['PACKAGE_STATUS'][0] === PackageStatus.CURRENT_STOWED
        || request.filters['PACKAGE_STATUS'][0] === PackageStatus.PROBLEM_SOLVE
        || request.filters['PACKAGE_STATUS'][0] === PackageStatus.CURRENT_INDUCTED)) {
        request.filters['DRS'] = ["FALSE"];
    }

    if(request.filters['SIDELINE_V2']) {
        let reInductDate = request.filters['SIDELINE_UNTIL_TIME'][0];
        delete request.filters['SIDELINE_UNTIL_TIME']
        request.rangeFilters = [getSidelineRangeFilter(reInductDate)]
    }

    return async (dispatch) => {
        try {
            dispatch(loadPackageListBegin());
            const startTime = Date.now();
            const packageList = await getPackages(request);
            if (packageList) {
                dispatch(loadPackageListSuccess(packageList));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadPackageListFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadPackageListFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const fetchPickedPackageList = (baseURL, nodeId, params) => {
    return async (dispatch) => {
        dispatch(loadPackageListBegin());
        try {
            const request = constructPickedPackagesRequest(nodeId, params)
            const packageList = await getPickPackages(request, baseURL);
            if (packageList) {
                dispatch(loadPackageListSuccess(packageList));
            } else {
                dispatch(loadPackageListFailure());
            }
        } catch (error) {
            dispatch(loadPackageListFailure());
        }
    }
}

const constructPickedPackagesRequest = (nodeId, queryParams) => {

    return {
        stationCode: nodeId,
        date: getDateInMMDDYYYYWithOffset(0),
        metric: queryParams.get(PACKAGE_STATUS),
        groupBy: queryParams.get(GROUP_BY),
        filters: constructFiltersForPicked(queryParams)
    }
}

const constructFiltersForPicked = (queryParams) => {
    const filters = {
        stationPair: [queryParams.get(STATION_PAIR)]
    }
    if (FLOOR_LOCATION === queryParams.get(GROUP_BY)) {
        return {
            ...filters,
            floorLocation: [queryParams.get(FLOOR)]
        }
    }
    return filters
}



// WEBPACK FOOTER //
// ./src/actions/PackageListActions.js